<script>
  import { onMount, createEventDispatcher } from "svelte";
  import ModalMessage from "../../components/HTMLElements/ModalMessage.svelte";
  import Modal from "../../components/HTMLElements/Modal.svelte";
  import {
    UpdateUserStore,
    User,
    askPushPermission,
    getUserSubscription,
    savePushSubscription,
    isPushSupported
  } from "../../store.js";
  import wrappedFetch from "../../wrappedFetch.js";
  import CheckBox from "../HTMLElements/CheckBoxInput.svelte";
  import Help from "../help.svelte";
  let error = "";
  let showEmailLinkSentMessage = false;
  let showUserDetailsUpdated = false;
  let info = "";
  let validated, privacyPolicyAccepted;
  validated = $UpdateUserStore.validated;
  let showUserEmailNotValidated = false;
  let showPrivacyModal = false;
  let resendingVerificationLink=false;
  let isConfirmingDetails = false;
  let laName = ".";

  showUserEmailNotValidated = $User && $User.isEmailValidated != "Y";

const viewPrivacy = async e => {
  e.preventDefault();
  showPrivacyModal = true;
}

  privacyPolicyAccepted = $UpdateUserStore.privacyPolicyAccepted;
  const confirmDetails = async e => {
    error = "";
    showUserDetailsUpdated = false;
    e.preventDefault();

    // if (!$UpdateUserStore.title || !$UpdateUserStore.address) {
    //   error += "Please enter all missing details.<br/>";
    // }
    if (!$UpdateUserStore.address) {
      error += "Please enter all missing details.<br/>";
    }

    if (!validated) {
      error = "Please confirm your details are correct. <br/>";
    }
    if (!privacyPolicyAccepted) {
      error += "Please confirm that you agree to the privacy policies.";
    }

    if (error == "") {
      isConfirmingDetails = true;
      const response = await wrappedFetch("user/setuservalidated");
      let result = await response.json();
      if (result.success) {
        $UpdateUserStore.validated = "Y";
        $UpdateUserStore.privacyPolicyAccepted = "Y";
        $User.isAccountValidated = "Y";
        showUserDetailsUpdated = true;
      }
      isConfirmingDetails = false;
    }
  };

  const dispatch = createEventDispatcher();
  const resendEmailVerificationLink = () => {
    resendingVerificationLink = true;
    wrappedFetch("user/SendEmailVerificationLink", { method: "post" })
      .then(res => res.json())
      .then(result => {
        if (result.success) {
          showUserEmailNotValidated = false;
          showEmailLinkSentMessage = true;
          //   info = "Your link has been sent";
          info =
            "<h4 class='title is-5'>A validation email has now been sent!</h4><p>Please find the email and click the link to validate. Please note you will need to validate your email address before you are able to proceed with making or amending an application. </p>";
        }
        resendingVerificationLink = false;
      });
  };
  let pushNotification;
  const checkSubscriptionExists = async () => {
    let subscription = await getUserSubscription();

    if (subscription) {
      let form = new FormData();
      form.append("subscription", JSON.stringify(subscription));
      const resp = await wrappedFetch(`/user/GetPushSubscription`, {
        method: "post",
        body: form
      });
      const r = await resp.json();
      return r;
    }
  };
  let isSubscribed = false;

  let pushBlocked = false;
  let pushGranted = false;
  let pushDisabled = false;
  let pushNotificationMessage = "";
  let messageNotificationBlocked =
    "You have blocked push notifications in this browser.";
  let messageNotificationAsk =
    "Please tick to  allow push notifications in this browser.";
  let messageNotificationAllowed =
    "You have allowed push notifications in this browser.";
  let messageNotificationNotSupported =
    "Push notification is not supported by this browser.";
  $:pushChecked = pushGranted;
  if (!isPushSupported) {
    pushDisabled = true;
    pushNotificationMessage = messageNotificationNotSupported;
  } else {
    if (Notification.permission == "denied") {
      pushBlocked = true;
      pushDisabled = true;
      pushNotificationMessage = messageNotificationBlocked;
    } else if (Notification.permission == "granted") {
      checkSubscriptionExists().then(result => {
        if(!result)
        {
          pushNotificationMessage = messageNotificationAsk;
          return;
        }
        pushNotification = result.data;
        // isSubscribed = pushNotification;
        if (pushNotification && pushNotification.id > 0) {
          pushGranted = true;
          pushNotificationMessage = messageNotificationAllowed;
        } else pushNotificationMessage = messageNotificationAsk;
      });
    } else if (Notification.permission == "default") {
      pushNotificationMessage = messageNotificationAsk;
    }
  }

  const onPushNotificationChange = async e => {
    e.preventDefault();
    if (pushChecked) {
      askPushPermission().then(async result => {
        if (result == "granted") {
          let save = await savePushSubscription();        
          if (save.success) {
            pushGranted = true;
            pushNotification = save.subscription;
            pushNotificationMessage = messageNotificationAllowed;
            dispatch("notification", "Opt-in was successful!");
          } else dispatch("notification", save.message);
          
        } else if (result == "denied") {
          pushNotificationMessage = messageNotificationBlocked;
          pushBlocked = true;
          pushDisabled = true;
        }
      });
    } else if (pushNotification) {
      let form = new FormData();
      form.append("id", pushNotification.id);
      const resp = await wrappedFetch(`/user/DeleteSubscription`, {
        method: "post",
        body: form
      })
        .then(resp => resp.json())
        .then(result => {
          if (result > 0) pushNotificationMessage = messageNotificationAsk;
        });
    }
  };

  //$:pushNotificationMessage = pushBlocked ? "You have blocked push notification": pushGranted ?"You have allowed push notification":"";
</script>

{#if $User && $User.isEmailValidated != 'Y'}
  <div class="notification is-primary">
    <p style="margin-bottom: 10px;">
      Your email address has not been validated. You will not receive any
      further emails or be able to make an application until you have completed
      the validation process.
    </p>
    <p style="margin-bottom: 10px;">
      You would have received an email to
      <strong>{$UpdateUserStore.email}</strong>
      with a link to validate your account. If you have not received this, then
      please resend it below. Alternatively you can change your email address by
      using the 'change details' button.
    </p>

      <button
        class="button is-default {resendingVerificationLink ? 'is-loading' : ''}"
        disabled={resendingVerificationLink}
        style="background-color: rgb(241, 241, 241);"
        on:click={resendEmailVerificationLink}>
        Resend validation email
      </button>

  </div>
{/if}

{#if $UpdateUserStore.address && $UpdateUserStore.address.addr}
{:else}
  <div class="notification is-primary">
    <p style="margin-bottom: 10px;">
      Your account has been created using your USO account, however to proceed with your application, please complete the missing details below
    </p>
  </div>
{/if}

<form action="">
  <h1 class="title is-3">Your details</h1>
  <p class="subtitle is-4">
    Please check and confirm your details are correct.
  </p>
  <div style="text-align: right;margin-top: 15px;">
    <a
      href="/useraccount/editaccount"
      class="button is-purple"
      style="margin-right:10px;">
      Change details
    </a>
  </div>
  <br />
  <!-- <label for="laName">{$UpdateUserStore.address.laName}</label> -->
  <nav class="panel">
    <div class="panel-heading">Personal Details</div>
    <div class="panel-block">
      <div class="column">Title</div>
      <div class="column">
        {#if $UpdateUserStore.title}
          <strong>{$UpdateUserStore.title}</strong>
        {:else}
          <span class="has-text-danger">Not Set</span>
        {/if}
      </div>
    </div>
    <div class="panel-block">
      <div class="column">First Name</div>
      <div class="column">
        <strong>{$UpdateUserStore.forename}</strong>
      </div>
    </div>
    <div class="panel-block">
      <div class="column">Last Name</div>
      <div class="column">
        <strong>{$UpdateUserStore.surname}</strong>
      </div>
    </div>
    <div class="panel-block">
      <div class="column">Address</div>
      <div class="column">

        {#if $UpdateUserStore.address && $UpdateUserStore.address.addr}
          <strong>
            {#each $UpdateUserStore.address.addr.split(',') as addr}
              {addr}<br/>
            {/each}
          </strong>
        {:else}
          <span class="has-text-danger">Not set</span>
        {/if}

      </div>
    </div>
  </nav>
  <nav class="panel">
    <div class="panel-heading">Contact Details</div>
    <div class="panel-block">
      <div class="column">Email Address</div>

      <div class="column" style="word-break:break-word;">
        <strong>{$UpdateUserStore.email}</strong>
      </div>

    </div>
    <div class="panel-block">
      <div class="column">Mobile Phone Number</div>

      <div class="column">
        <strong>{$UpdateUserStore.mobile || ''}</strong>
      </div>

    </div>
    <div class="panel-block">
      <div class="column">Landline Phone Number</div>

      <div class="column">
        <strong>{$UpdateUserStore.homePhone || ''}</strong>
      </div>

    </div>
    <div class="panel-block">
      <div class="column">Work Phone Number</div>

      <div class="column">
        <strong>{$UpdateUserStore.workPhone || ''}</strong>
      </div>

    </div>
  </nav>
  <nav class="panel">
    <div class="panel-heading">Options</div>
    <div class="panel-block" style="display:none">
      <div class="column">
      Receive SMS
      </div>
      <div class="column">
        <strong>
          {#if $UpdateUserStore.receiveSMS == 'Y'}Yes{:else}No{/if}
        </strong>
      </div>
    </div>
    <div class="panel-block">
      <div class="column">
      Crown Servant
      </div>
      <div class="column">
        <strong>
          {#if $UpdateUserStore.isMemberOfCrownService == 'Y'}Yes{:else}No{/if}
        </strong>
      </div>
    </div>

{#if isPushSupported}
    <div class="panel-block">
      <div class="column">
        <CheckBox
          label="Push Notifications"
          bind:checked={pushChecked}
          bind:isDisabled={pushDisabled}
          isLabelBold={true}
          on:change={onPushNotificationChange} />
        {#if pushNotificationMessage != ''}
          <p
            class={pushBlocked || !isPushSupported ? 'help is-danger' : 'help'} style="margin-bottom:0px;">
            {pushNotificationMessage}
          </p>
        {/if}
      </div>
    </div>
    {/if}

    <!-- <div class="panel-block">
                                <div class="column">
                                    <strong>Agreed to the privacy policy</strong></div>
                                    <div class="column"><strong>{#if UserDetails.isPrivacyPolicyAgreed == 'Y'} Yes {:else}No {/if}</strong></div>

                            </div> -->
    <!-- </nav> -->
    <br />
    {#if $UpdateUserStore.validated != 'Y'}
      <div class="field">
        <label class="checkbox">
          <input type="checkbox" bind:checked={validated} />
          I confirm my personal details are correct
        </label>
      </div>
    {/if}
    {#if $UpdateUserStore.privacyPolicyAccepted != 'Y'}
      <div class="field">
        <label class="checkbox">
          <input type="checkbox" bind:checked={privacyPolicyAccepted} />
          <span>I agree to the</span>
        <a
            href="#"
            on:click={viewPrivacy}
            style="margin-left:4px; cursor: pointer;">
            privacy policy
          </a>
        </label>
      </div>
    {/if}
    {#if error != ''}
      <div class="notification is-invalid">
        <p class="help" style="margin-bottom:0px">{@html error}</p>
      </div>
    {/if}

    <div style="text-align: right;margin-top: 15px;">
      <!-- <a
        href="/useraccount/editaccount"
        class="button"
        style="margin-right:10px;">
        Change details
      </a> -->
      {#if $UpdateUserStore.validated != 'Y' || $UpdateUserStore.privacyPolicyAccepted != 'Y'}
        <button on:click={confirmDetails}  class="button is-primary {isConfirmingDetails ? 'is-loading' : ''}" disabled={isConfirmingDetails}>
          Confirm details
        </button>
      {/if}
      {#if $UpdateUserStore.validated == 'Y' || $UpdateUserStore.privacyPolicyAccepted == 'Y'}
        <a
          class="button is-primary"
          href="#"
          on:click|preventDefault={() => {
            dispatch('pageChange', '/user/home/');
          }}>
          Home Page
        </a>
      {/if}

    </div>
  </nav>
</form>
<ModalMessage
  bind:showModal={showEmailLinkSentMessage}
  on:continue={() => {
    showEmailLinkSentMessage = false;
  }}>
  {#if info != ''}
    <div class="field">
      <p>
        {@html info}
      </p>
    </div>
  {/if}
</ModalMessage>

<ModalMessage
  bind:showModal={showUserDetailsUpdated}
  on:continue={() => {
    showUserDetailsUpdated = false;
    dispatch('pageChange', '/user/home/');
  }}>
  <div class="field">
    <p>Thank you for confirming your details</p>
  </div>
</ModalMessage>


<Modal bind:showModal={showPrivacyModal}>
<Help
  helpId ={'Help16'}
  isPopup={true} />
</Modal>

  <Modal showModal={showUserEmailNotValidated}>
    <div class="">
      <h1 class="title is-4">Email address not validated</h1>
      <p style="margin-bottom: 10px;">
        Your email address has not been validated. You will not receive any
        further emails or be able to make an application until you have completed
        the validation process.
      </p>
      <p style="margin-bottom: 10px;">
        You would have received an email to
        <strong>{$UpdateUserStore.email}</strong>
        with a link to validate your account. If you have not received this, then
        please resend it below. Alternatively you can change your email address by
        clicking 'Continue' and then using the 'change details' button.
      </p>
    </div>

    <footer class="modal-card-foot buttons is-right" slot="footer">
      <button    
        class="button is-purple {resendingVerificationLink ? 'is-loading' : ''}"
        disabled={resendingVerificationLink}
        on:click={resendEmailVerificationLink}>
        Resend validation email
      </button>

      <button
        class="button continue is-primary"
        on:click={() => (showUserEmailNotValidated = false)}>
        Continue
      </button>

    </footer>
  </Modal>
